export const CHAT_PAGE = 'chat/CHAT_PAGE'
export const ERROR_PAGE = 'chat/ERROR_PAGE'
